var zlib = window.Zlib;
import {
    DataTexture,
    RGBAFormat,

} from "three"
class IntegrateBRDF {
    constructor(urlOrData, size) {
        this._size = size;
        if (typeof urlOrData === 'string') this._file = urlOrData;
        else this._data = urlOrData;
    }
    isGunzipBuffer(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        return typedArray[0] === 0x1f && typedArray[1] === 0x8b;
    };
    loadBRDFPacked() {
        let self = this;
        var readInputArray = function (inputArray) {
            var data = inputArray;
            if (self.isGunzipBuffer(data)) data = self.gunzip(data);
            var byteSize = self._size * self._size * 4;
            var imageData = new Uint8Array(data, 0, byteSize);
            var _texture = new DataTexture(imageData, self._size, self._size, RGBAFormat);
            self.brdfTexture = _texture;
            return _texture;
        }

        return readInputArray(this._data);
    }
    gunzip(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        // var zlib = require('zlib');
        if (!zlib) {
            console.error('zlib is not exit')
        }
        var zdec = new zlib.Gunzip(typedArray);
        var result = zdec.decompress();
        return result.buffer;
    }
}
export default IntegrateBRDF